<template>
  <div class="admin-users">
    <page-title title="筛选">
      <el-row :gutter="20" class="admin-users__filter-header">
        <el-col :xl="3" :span="6">
          <span>发票申请号：</span>
          <el-input v-model="filter.invoiceNo" placeholder="请输入"></el-input>
        </el-col>
        <el-col :xl="3" :span="6">
          <span>注册手机号：</span>
          <el-input v-model="filter.phone" placeholder="请输入"></el-input>
        </el-col>
        <el-col :xl="4" :span="6">
          <span>申请状态：</span>
          <el-select clearable v-model="filter.status" placeholder="请选择">
            <el-option
              v-for="s in STATUS"
              :label="STATUS_zh[s]"
              :value="s"
              :key="s"
            ></el-option>
          </el-select>
        </el-col>
        <el-col :xl="10" :span="10">
          <span>申请时间区间：</span>
          <el-date-picker
            style="width: 100%;"
            @change="handleFormatDate"
            v-model="value2"
            type="daterange"
            align="right"
            :default-time="['23:59:59', '00:00:00']"
            value-format="yyyy-MM-dd"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
          >
          </el-date-picker>
        </el-col>
        <el-col :xl="3" :span="6">
          <el-button @click="getList">查询</el-button>
          <el-button
            @click="
              filter = {};
              value2 = [];
              getList();
            "
            >重置</el-button
          >
        </el-col>
      </el-row>
    </page-title>
    <page-title title="数据列表">
      <div class="admin-users__body">
        <el-table
          :data="usersData"
          style="width: 100%"
          :header-cell-style="{ backgroundColor: `#f7f7f7` }"
          v-loading="loading"
        >
          <el-table-column type="index" width="50" align="center">
          </el-table-column>
          <el-table-column prop="invoiceNo" label="发票申请号">
          </el-table-column>
          <el-table-column prop="invoiceCount" label="开票金额">
            <template slot-scope="{ row }">
              <span v-if="row.invoiceCount">￥{{ row.invoiceCount }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="userInfo.mobile" label="注册手机号">
          </el-table-column>
          <el-table-column label="申请状态">
            <template slot-scope="{ row }">
              <user-state-label :status="row.status"></user-state-label>
            </template>
          </el-table-column>
          <el-table-column prop="createdDate" label="申请时间">
            <template slot-scope="{ row }">
              {{ moment(row.createdDate).format("YYYY-MM-DD HH:mm") }}
            </template>
          </el-table-column>
          <el-table-column prop="modifiedDate" label="处理时间">
            <template slot-scope="{ row }">
              {{ moment(row.modifiedDate).format("YYYY-MM-DD HH:mm") }}
            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" min-width="100">
            <template slot-scope="{ row }">
              <span
                @click="handleDetail(row)"
                style="text-decoration:none;color:#005BFF;"
                >详情</span
              >

              <!-- <router-link
                
                :to="`/bill/detail?detail=${JSON.stringify(row)}`"
              >
                <span>详情</span>
              </router-link> -->
            </template>
          </el-table-column>
        </el-table>
        <cus-pagination
          :total="total"
          :current-page.sync="currentPage"
          :page-size.sync="pageSize"
          @size-change="getList"
        ></cus-pagination>
      </div>
    </page-title>
  </div>
</template>
<script>
import PageTitle from "@/components/pageTitle.vue";
import CusPagination from "@/components/cusPagination.vue";
import UserStateLabel from "./components/userStateLabel";
import { billPage } from "@/api/req";
import { TYPE, TYPE_zh, STATUS, STATUS_zh } from "./_eum";

export default {
  name: "users",
  components: {
    PageTitle,
    CusPagination,
    UserStateLabel,
  },
  data() {
    return {
      filter: {},
      usersData: [],
      value2: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      loading: true,
    };
  },
  computed: {
    TYPE: () => TYPE,
    TYPE_zh: () => TYPE_zh,
    STATUS: () => STATUS,
    STATUS_zh: () => STATUS_zh,
  },
  watch: {
    currentPage() {
      this.getList();
    },
  },
  methods: {
    handleFormatDate(value) {
      if (!value) {
        this.filter.startDate = "";
        this.filter.endDate = "";
      }
      this.filter.startDate = value[0];
      this.filter.endDate = value[1];
    },
    getList() {
      this.loading = true;
      const req = {
        pageSize: this.pageSize,
        pageNumber: this.currentPage,
        ...this.filter,
      };
      this.$ajax
        .get(billPage, req)
        .then(({ data }) => {
          this.total = data.total;
          this.usersData = Object.freeze(data.rows);
          this.loading = false;
        })
        .catch((err) => {
          console.log("err.data :>> ", err.data);
          this.loading = false;
        });
    },
    handleDetail(row) {
      sessionStorage.setItem("billDetial", JSON.stringify(row));
      this.$router.push("/bill/detail");
    },
  },
  created() {
    const { query } = this.$route;
    if (JSON.stringify(query) !== "{}") {
      this.filter = Object.assign(this.filter, query);
    }
    this.getList();
  },
};
</script>
